import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import LogoBWS from "../../img/bws-logo.svg";
import AboutImg from "../../img/about-img.webp";
import SiteDecor from "../../img/site-decor.webp"

function About({ aboutData }) {

    return (
        <>
            {aboutData && (
                <section className="relative mb-[60px] md:mb-[120px]" id="about">
                   
                    <div className="container max-w-screen-xl mx-auto px-[15px]">

                        <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                            <div className="relative bg-[linear-gradient(280deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]
                                flex flex-col items-center justify-between py-14 px-[15px] -ml-[15px] -mr-[15px] 
                                md:flex-row md:items-start md:ml-0 md:mr-0 md:gap-8 
                                lg:p-14 lg:gap-16 mb-[60px] xl:mb-[120px]">

                                <div className="flex flex-col items-center text-white text-center md:text-left md:items-start max-w-[680px] z-10">
                                    <h3 className="font-bold uppercase text-3xl mb-8 md:mb-6 lg:text-[42px] xl:text-[52px]">Про захід</h3>
                                    <a href="/" className="block max-w-[190px] mb-16 md:hidden">
                                        <img src={LogoBWS} alt="Logo BWS" />
                                    </a>
                                    <p className="font-bold text-lg xl:text-2xl">
                                        Business Wisdom Summit — ключова подія про стійкість та розвиток бізнесу під час війни від бізнес/медіа бюро ekonomika+ і журналу «ТОП-100. Рейтинги найбільших»
                                    </p>
                                </div>

                                <a href="/" className="hidden md:block md:w-full md:max-w-[302px] z-10">
                                    <img src={LogoBWS} alt="Logo BWS" />
                                </a>

                                <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 
                                    md:w-[350px] md:left-3/4 xl:left-[70%]">
                                    <img src={SiteDecor} alt="decor" className="w-full"/>
                                </div>
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                            <div className="md:flex md:gap-6 md:justify-between">

                                <div className="md:w-full md:max-w-[560px]">
                                    <h3 className="text-3xl text-white font-bold uppercase bg-[#3ac097] py-2 px-5
                                        -ml-[15px] -mr-[15px] mb-7 md:ml-0 md:mr-0 md:inline-block xl:text-[46px] xl:py-3">Бізнеси сміливих</h3>
                                    <p className="mb-4 text-base lg:text-lg">Що сьогодні рухає український бізнес уперед — попри війну, турбулентність і постійну невизначеність?</p>
                                    <p className="mb-4 text-base lg:text-lg">Не обставини. А рішення.</p>
                                    <p className="mb-4 text-base lg:text-lg"><strong>Бізнеси сміливих</strong> — це компанії, які не чекають стабільності, а створюють її, не працюють «на виживання», а мислять категоріями системи, масштабування і довгої гри. Бізнеси, що беруть відповідальність за свої команди, партнерства, галузі та країну.</p>
                                    <img src={AboutImg} className="md:hidden mb-4" alt="img BWS" />
                                    <p className="mb-4 text-base lg:text-lg"><strong>Business Wisdom Summit 2026</strong> — це подія про тих, хто сьогодні формує новий вектор української економіки.</p>
                                    <p className="mb-4 text-base lg:text-lg">У центрі саміту — реальні бізнеси сміливих:</p>
                                    <ul>
                                        <li className="relative pl-6 text-base lg:text-lg mb-4">
                                            <span className="absolute left-0 top-[0.55em] w-[10px] h-[10px] bg-[#009064] rounded-full"></span>
                                            компанії, що вистояли та масштабуються під тиском
                                        </li>

                                        <li className="relative pl-6 text-base lg:text-lg mb-4">
                                            <span className="absolute left-0 top-[0.55em] w-[10px] h-[10px] bg-[#009064] rounded-full"></span>
                                            лідери, які диверсифікували ризики й вийшли на нові ринки
                                        </li>

                                        <li className="relative pl-6 text-base lg:text-lg mb-4">
                                            <span className="absolute left-0 top-[0.55em] w-[10px] h-[10px] bg-[#009064] rounded-full"></span>
                                            управлінці, які модернізували операції та зберегли команди
                                        </li>

                                        <li className="relative pl-6 text-base lg:text-lg mb-4">
                                            <span className="absolute left-0 top-[0.55em] w-[10px] h-[10px] bg-[#009064] rounded-full"></span>
                                            підприємці, що трансформують кризу на можливості
                                        </li>
                                    </ul>
                                </div>

                                <div className="hidden md:block md:w-full md:max-w-[568px]">
                                    <img src={AboutImg} className="h-full object-cover" alt="img BWS" />
                                </div>

                            </div>
                        </ScrollAnimation>

                    </div>
                </section>
            )}
        </>
    );

}

export default About